import React, { useEffect, useState } from 'react'
import { sectionStyles } from './section-styles'
import { LeftBox } from './Order-Section-Left'
import { RightBox } from './Order-Section-Right'
import { RightBoxPay } from '../pay-section/Order-Section-Right-Pay'
import { getTableOrderListWithOptionItems } from '../../../lib/onlpos-utils'
import { debug } from '../../../../../settings'

export function OrderSection(props) {
  const { selectedTableInfo, orderList } = props
  const { visiblePaySection } = props

  /**
   * @순수_order_정보_리스트
   */

  const [tableOrderList, setTableOrderList] = useState([])

  useEffect(() => {
    const res = getTableOrderListWithOptionItems({
      orderList,
      tableInfo: selectedTableInfo,
    })
    setTableOrderList(res.tableOrderList)
    if (debug) {
      console.log('-'.repeat(50),'tableOrderList')
      console.table(res.tableOrderList)
    }
  }, [orderList])

  const allProps = { ...props, tableOrderList }

  const styles = {
    wrap: {
      ...sectionStyles.wrap,
      backgroundColor: '#fff',
      display: 'flex',
    },
  }
  return (
    <div style={styles.wrap}>
      <LeftBox {...allProps} />
      {!visiblePaySection && <RightBox {...allProps} />}
      {visiblePaySection && <RightBoxPay {...allProps} />}
    </div>
  )
}
